// cog-spektrix-pathway.js
import "./spektrix-booking-pathway/router.js";
